import React from 'react'
import './about.css'
import me from '../../assets/me.png'
import {BsCodeSlash} from 'react-icons/bs'
import {SiSpring} from 'react-icons/si'
import {BiData} from 'react-icons/bi'
import CallToAction from './CallToAction.jsx'

const About = () => {
  return (
    <section id="about">
      <h2>About me</h2>
       <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={me} alt="me"/>
          </div>
        </div>
        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <BsCodeSlash className="about__icon"/>
              <h3>Backend Developer</h3>
              <small>Specialized in Java and Spring Boot ecosystem</small>
            </article>
            <article className="about__card">
             <BiData className="about__icon"/>
              <h3>Database Design</h3>
              <small>Experience with SQL and NoSQL databases</small>
            </article>
            <article className="about__card">
             <SiSpring className="about__icon"/>
              <h3>API Development</h3>
              <small>RESTful APIs and microservices architecture</small>
            </article>
          </div>
          <p>I am a backend developer specializing in Java and the Spring ecosystem. I have experience building robust and scalable applications, working with Spring Boot, REST APIs, and database management. I focus on writing clean, maintainable code and implementing best practices in software architecture. I'm passionate about solving complex problems and continuously learning new technologies</p>
            <CallToAction/>
        </div>
       </div>
    </section>
  )
}

export default About